'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_LeftMenu$MenuItem$() {
}
export { $c_Lpresto_LeftMenu$MenuItem$ as $c_Lpresto_LeftMenu$MenuItem$ };
$p = $c_Lpresto_LeftMenu$MenuItem$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_LeftMenu$MenuItem$;
/** @constructor */
function $h_Lpresto_LeftMenu$MenuItem$() {
}
export { $h_Lpresto_LeftMenu$MenuItem$ as $h_Lpresto_LeftMenu$MenuItem$ };
$h_Lpresto_LeftMenu$MenuItem$.prototype = $p;
$p.l = (function() {
  return "MenuItem";
});
$p.Gy = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((_$5) => false));
});
var $d_Lpresto_LeftMenu$MenuItem$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_LeftMenu$MenuItem$, "presto.LeftMenu$MenuItem$", ({
  KL: 1,
  e: 1,
  g: 1
}));
export { $d_Lpresto_LeftMenu$MenuItem$ as $d_Lpresto_LeftMenu$MenuItem$ };
var $n_Lpresto_LeftMenu$MenuItem$;
function $m_Lpresto_LeftMenu$MenuItem$() {
  if ((!$n_Lpresto_LeftMenu$MenuItem$)) {
    $n_Lpresto_LeftMenu$MenuItem$ = new $c_Lpresto_LeftMenu$MenuItem$();
  }
  return $n_Lpresto_LeftMenu$MenuItem$;
}
export { $m_Lpresto_LeftMenu$MenuItem$ as $m_Lpresto_LeftMenu$MenuItem$ };
//# sourceMappingURL=presto.-Left-Menu$-Menu-Item$.js.map
